// import { useState } from 'react';
import Admin from './admin';
import Analytics from './Depatment/Analytics';
import Audit_Complaince from './Depatment/Audit_Complaince';
import CommissionRatna from './Depatment/CommissionRatna';
import Corporate from './Depatment/Corporate';
import Finance_Account from './Depatment/Finance_Account';
import Hr_Admin from './Depatment/Hr_Admin';
import IT from './Depatment/IT';
import Dashboards from './Depatment/MainDepartment';
import Marketing from './Depatment/Marketing';
import Operations from './Depatment/Operation';
import Revenue_Assurance from './Depatment/Revenue_Assurance';
import Sales from './Depatment/Sales';
import Hardware from './Hardware';
// import Agreement from './Agreement';
import Limit from './Limit';
import mapping from './mapping';
import Pages from './Pages';
import procurement from './Procurement';
import Recon from './Recon';
import Services from './Services';
import Mandate from './Mandate';
import Wallet from './Wallet';
import Hr from './Hr';
import Dev from './Dev';

// ==============================|| MENU ITEMS ||============================== //

// const [Access,setAccess]=useState(null)

const menuItems = {
  items: [
    Admin,
    Pages,
    mapping,
    procurement,
    Limit,
    Services,
    Hr,
    Mandate,
    Recon,
    Hardware,
    Analytics,
    Audit_Complaince,
    Corporate,
    Finance_Account,
    Hr_Admin,
    IT,
    Marketing,
    Operations,
    Revenue_Assurance,
    Sales,
    CommissionRatna,
    Dashboards,
    Wallet,
    Dev
  ]
};

export default menuItems;
